import { Injectable } from '@angular/core';
import * as _ from 'lodash';
@Injectable()
export class Support {

    constructor() {
    }

    public static toQueryParams(obj, prefix?): any {
        var str = [],
            p;
        for (p in obj) {
            if (obj.hasOwnProperty(p)) {
                var k = prefix ? prefix + '[' + p + ']' : p,
                    v = obj[p];
                str.push(
                    v !== null && typeof v === 'object'
                        ? this.toQueryParams(v, k)
                        : encodeURIComponent(k) + '=' + encodeURIComponent(v)
                );
            }
        }
        return str.join('&');
    }

    /*     public static get_text_width(txt, font) {
            let element = document.createElement('canvas');
            let context = element.getContext("2d");
            context.font = font;
            return context.measureText(txt).width;
        } */

    public static sortBy(obj, prop: string) {
        return (_.isArray(obj)) ? obj.sort((a, b) => a[prop] > b[prop] ? 1 : a[prop] === b[prop] ? 0 : -1) : obj;
    }

    public static numberToBoolean(val: number | string) {
        if (_.isString(val)) {
            let lowercaseVal = _.toLower(val);
            if (lowercaseVal == 'true') return true;
            else if (lowercaseVal == 'false') return false;
            else val = _.toNumber(val);
        }
        return val ? true : false;
    }

    public static formatBytes(bytes, decimals) {
        if (bytes === 0) {
            return '0 Bytes';
        }
        const k = 1024;
        const dm = decimals <= 0 ? 0 : decimals || 2;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

}
